export default [
  {
    path: '/networks',
    name: 'networks',
    component: () => import('@/views/Networks/Networks.vue'),
    meta: {
      pageTitle: 'List All Netowrks',
      breadcrumb: [
        {
          text: 'Devices',
          active: true,
        },
      ],
    },
  },
  {
    path: '/networks/addNetwork',
    name: 'addNetwork',
    component: () => import('@/views/Networks/AddNetwork/AddNetwork.vue'),
    meta: {
      pageTitle: 'Add Network',
      breadcrumb: [
        {
          text: 'Add Devices',
          active: true,
        },
      ],
    },
  },
]
